import React, { Fragment } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Spinner from 'react-bootstrap/Spinner'
import MaskedInput from 'react-text-mask'
import isValidCep from '@brazilian-utils/is-valid-cep'
import { onlyNumbers } from '@brazilian-utils/helper-only-numbers'

import SharedService from './../../services/shared.service'

const NUMBER_REGEX = /^\d*$/

class Enderecos extends React.Component {
  state = {
    loadingCEP: false,
    invalidCEP: false,
  }

  onBlurCEP = (e) => {
    e.preventDefault()
    if (isValidCep(e.target.value)) {
      this.setState({
        loadingCEP: true,
      })
      SharedService.consultarCEP(onlyNumbers(e.target.value))
        .then(({ data }) => {
          this.updateAddress(data)
        })
        .catch(() => {
          this.setState({
            loadingCEP: false,
            invalidCEP: true,
          })
        })
    }
  }

  updateAddress = (data) => {
    const { endereco, index } = this.props

    if (data.logradouro == null) {
      endereco.logradouro = ''
      endereco.bairro = ''
      endereco.cidade = ''
      endereco.estado = ''

      this.setState({
        loadingCEP: false,
        invalidCEP: true,
      })

      this.props.onChange(index, endereco)

      return
    }
    endereco.logradouro = data.logradouro
    endereco.bairro = data.bairro
    endereco.cidade = data.cidade
    endereco.estado = data.estado
    this.setState({
      loadingCEP: false,
      invalidCEP: false,
    })
    this.props.onChange(index, endereco)
  }

  onChange = (e) => {
    const { index, endereco } = this.props
    endereco[e.target.name] = e.target.value
    this.props.onChange(index, endereco)
  }

  onChangeNumero = ({ target }) => {
    const { index, endereco } = this.props
    if (NUMBER_REGEX.test(target.value)) {
      endereco[target.name] = target.value
    }
    this.props.onChange(index, endereco)
  }

  render() {
    const { endereco, disableAll } = this.props
    return (
      <Fragment>
        <Row className="form-row mt-1">
          <Col xs={12}>
            <Form.Group className="required mb-2">
              <Form.Label htmlFor="cep" className="d-flex align-items-center flex-wrap mb-1">
                CEP
                {this.state.loadingCEP && (
                  <Spinner animation="grow" variant="primary" size="sm" className="ml-2" />
                )}
              </Form.Label>
              <Row className="form-row align-items-center mx-0">
                <Col xs={12} sm={6} md={4} lg={3} className="pl-0 pr-sm-2">
                  <MaskedInput
                    mask={[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
                    className={this.state.invalidCEP ? 'form-control is-invalid' : 'form-control'}
                    id="cep"
                    name="cep"
                    value={endereco.cep}
                    onChange={this.onChange}
                    onBlur={this.onBlurCEP}
                    required
                    disabled={this.state.loadingCEP || disableAll}
                  />
                  {this.state.invalidCEP && <div className="invalid-feedback d-block">CEP inválido</div>}
                </Col>
                <Col xs={12} md={8} lg={9} className="d-none d-md-flex align-items-center pl-md-2 pr-0">
                  <small className="text-muted mb-0 text-left" style={{ fontSize: '0.75rem', lineHeight: 1.35 }}>
                    Informe o CEP para preencher logradouro, bairro, cidade e UF automaticamente.
                  </small>
                </Col>
                <Col xs={12} className="d-md-none px-0 mt-2">
                  <small className="text-muted d-block mb-0" style={{ fontSize: '0.75rem', lineHeight: 1.35 }}>
                    Informe o CEP para preencher logradouro, bairro, cidade e UF automaticamente.
                  </small>
                </Col>
              </Row>
            </Form.Group>
          </Col>
        </Row>

        <Row className="form-row align-items-end">
          <Col xs={12} sm={8} md={9} lg={9}>
            <Form.Group className="required mb-2">
              <Form.Label htmlFor="logradouro">Logradouro</Form.Label>
              <Form.Control
                type="text"
                id="logradouro"
                name="logradouro"
                value={endereco.logradouro}
                onChange={this.onChange}
                required
                maxLength={100}
                disabled={disableAll}
                placeholder="Rua, avenida, etc."
              />
            </Form.Group>
          </Col>
          <Col xs={12} sm={4} md={3} lg={3}>
            <Form.Group className="required mb-2">
              <Form.Label htmlFor="numero">Número</Form.Label>
              <Form.Control
                type="text"
                id="numero"
                name="numero"
                value={endereco.numero}
                onChange={this.onChangeNumero}
                required
                maxLength={10}
                disabled={disableAll}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="form-row align-items-end">
          <Col xs={12} sm={6} md={3} lg={3}>
            <Form.Group className="mb-2">
              <Form.Label htmlFor="complemento">Complemento</Form.Label>
              <Form.Control
                type="text"
                id="complemento"
                name="complemento"
                value={endereco.complemento || ''}
                onChange={this.onChange}
                maxLength={100}
                disabled={disableAll}
                placeholder="Apto, bloco..."
              />
            </Form.Group>
          </Col>
          <Col xs={12} sm={6} md={3} lg={3}>
            <Form.Group className="required mb-2">
              <Form.Label htmlFor="bairro">Bairro</Form.Label>
              <Form.Control
                type="text"
                id="bairro"
                name="bairro"
                value={endereco.bairro}
                onChange={this.onChange}
                maxLength={100}
                required
                readOnly
                disabled={disableAll}
              />
            </Form.Group>
          </Col>
          <Col xs={12} sm={8} md={4} lg={4}>
            <Form.Group className="required mb-2">
              <Form.Label htmlFor="cidade">Cidade</Form.Label>
              <Form.Control
                type="text"
                id="cidade"
                name="cidade"
                value={endereco.cidade}
                onChange={this.onChange}
                maxLength={100}
                required
                readOnly
                disabled={disableAll}
              />
            </Form.Group>
          </Col>
          <Col xs={12} sm={4} md={2} lg={2}>
            <Form.Group className="required mb-2">
              <Form.Label htmlFor="estado">UF</Form.Label>
              <Form.Control
                type="text"
                id="estado"
                name="estado"
                value={endereco.estado}
                onChange={this.onChange}
                maxLength={100}
                required
                readOnly
                disabled={disableAll}
                style={{ maxWidth: '100%' }}
              />
            </Form.Group>
          </Col>
        </Row>
      </Fragment>
    )
  }
}

export default Enderecos
